import { textVariant } from './Text'
import { CheckboxComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'
import { createStyles } from '@codeleap/styles'

const createCheckboxVariant = createStyles<CheckboxComposition>

export const CheckboxStyles = {
  default: createCheckboxVariant(theme => {
    const iconSize = theme.values.iconSize[2]
    const boxSize = 28
    return {
      box: {
        borderRadius: theme.radius.small,
        height: boxSize,
        width: boxSize,
        ...theme.presets.center,
        ...theme.border({
          color: theme.baseColors.neutralSolid400,
          width: theme.stroke.regular,
        }),
        cursor: 'pointer',
      },
      'box:disabled': {
        borderColor: theme.baseColors.neutralSolid300,
        cursor: 'not-allowed',
      },
      'box:unchecked': {
        backgroundColor: '#0000',
        ...theme.border({
          color: theme.baseColors.neutralSolid400,
          width: theme.stroke.regular,
        }),
      },
      'box:disabled-unchecked': {
        ...theme.border({
          color: theme.baseColors.neutralSolid200,
          width: theme.stroke.regular,
        }),
      },
      'box:checked': {
        backgroundColor: theme.baseColors.primarySolid800,
        ...theme.border({
          color: theme.baseColors.primarySolid800,
          width: theme.stroke.regular,
        }),
      },
      'box:disabled-checked': {
        backgroundColor: theme.baseColors.primarySolid50,
        ...theme.border({
          color: theme.baseColors.primarySolid50,
          width: theme.stroke.regular,
        }),
      },
      checkmarkWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      'checkmarkWrapper:checked': {
        scale: 1,
      },
      'checkmarkWrapper:unchecked': {
        scale: 0,
      },
      checkmark: {
        height: iconSize,
        width: iconSize,
        color: theme.baseColors.neutralSolid0,
      },
      errorMessage: {
        ...textVariant('p4'),
        color: theme.baseColors.redSolid400,
        ...theme.spacing.marginTop(1),
      },
      label: {
        ...textVariant('p1'),
        color: theme.baseColors.neutralSolid700,
        marginRight: theme.spacing.value(1),
        marginBottom: theme.spacing.value(0),
        cursor: 'pointer',
      },
      'label:disabled': {
        color: theme.baseColors.neutralSolid500,
        cursor: 'not-allowed',
      },
      description: {
        ...textVariant('p4'),
        color: theme.baseColors.neutralSolid700,
        marginBottom: theme.spacing.value(0),
      },
      wrapper: {
        ...theme.presets.row,
        ...theme.presets.alignCenter,
      },
      innerWrapper: {
        ...theme.presets.alignCenter,
      },
    }
  }),
  left: createCheckboxVariant(theme => ({
    __props: {
      checkboxOnLeft: true,
    },
    label: {
      ...textVariant('p1'),
      marginLeft: theme.spacing.value(1),
      marginBottom: theme.spacing.value(0),
    },
    innerWrapper: {
      marginLeft: theme.spacing.value(0),
      ...theme.presets.center,
    },
  })),

  circle: createCheckboxVariant(theme => {
    const boxSize = 20
    return {
      box: {
        borderRadius: theme.radius.infinite,
        height: boxSize,
        width: boxSize,
        ...theme.presets.center,
        ...theme.border({
          color: theme.baseColors.neutralSolid400,
          width: theme.stroke.regular,
        }),
        cursor: 'pointer',
      },
      'box:disabled': {
        borderColor: theme.baseColors.neutralSolid300,
        cursor: 'not-allowed',
      },
      'box:unchecked': {
        backgroundColor: '#0000',
        ...theme.border({
          color: theme.baseColors.neutralSolid500,
          width: theme.stroke.small,
        }),
      },
      'box:disabled-unchecked': {
        ...theme.border({
          color: theme.baseColors.neutralSolid200,
          width: theme.stroke.regular,
        }),
      },
      'box:checked': {
        backgroundColor: theme.baseColors.primarySolid500,
        ...theme.border({
          color: theme.baseColors.primarySolid500,
          width: theme.stroke.regular,
        }),
      },
      'box:disabled-checked': {
        backgroundColor: theme.baseColors.primarySolid50,
        ...theme.border({
          color: theme.baseColors.primarySolid50,
          width: theme.stroke.regular,
        }),
      },
      checkmarkWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      'checkmarkWrapper:checked': {
        scale: 1,
      },
      'checkmarkWrapper:unchecked': {
        scale: 0,
      },
      checkmark: {
        height: boxSize / 2,
        width: boxSize / 2,
        borderRadius: theme.radius.infinite,
        backgroundColor: theme.baseColors.neutralSolid0,
      },
      errorMessage: {
        ...textVariant('p4'),
        color: theme.baseColors.redSolid400,
        ...theme.spacing.marginTop(1),
      },
      label: {
        ...textVariant('p1'),
        color: theme.baseColors.neutralSolid700,
        marginRight: theme.spacing.value(1),
        marginBottom: theme.spacing.value(0),
        cursor: 'pointer',
      },
      'label:disabled': {
        color: theme.baseColors.neutralSolid500,
        cursor: 'not-allowed',
      },
      description: {
        ...textVariant('p4'),
        color: theme.baseColors.neutralSolid700,
        marginBottom: theme.spacing.value(0),
      },
      wrapper: {
        ...theme.presets.row,
        ...theme.presets.alignCenter,
      },
      innerWrapper: {
        ...theme.presets.alignCenter,
      },
    }
  }),
}

StyleRegistry.registerVariants('Checkbox', CheckboxStyles)
